<template>
    <div class="GamesCarouselItem">
        <div class="GamesCarouselCard">
            <img :src="imageSource" alt="game" />
        </div>
        <h3 v-t="`memogenius.games.${gameId}.title`" class="title" />

        <p>Lorem Ipsum dolor et ineger.</p>
    </div>
</template>

<script>
export default {
    props: {
        gameId: {
            type: String,
            required: true
        }
    },
    computed: {
        imageSource() {
            return require(`@/assets/images/memogenius/game/icon/${this.gameId}.png`);
        }
    }
};
</script>

<style lang="scss" scoped>
.GamesCarouselItem {
    .GamesCarouselCard {
        width: 232px;
        height: 363px;
        box-shadow: 0px 2px 23px 3px rgba(79, 79, 79, 0.1);
        border-radius: 4px;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            width: 5em;
            height: 5em;
        }
    }
    .title {
        color: black;
        font-weight: 500;
        font-size: 20px;
        margin: 1em 0 0.5em;
    }
    p {
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #727272;
        margin-top: 0;
    }
}
</style>
